module.exports = __webpack_public_path__ + "img/complaints.23ef1486.svg";